/*
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign
  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/
(function(){
	"use strict";
	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;
  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;
	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }
	/* the main product select element */
	var productSelect = document.querySelector('.product__info-container .product-form form input[name="id"]');
	if(!productSelect){ log('Could not find the main select element'); return }
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');

	var iconButton = '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_155_1446)"><path d="M17.75 3V7.5H13.25" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8674 11.25C15.3799 12.6299 14.4571 13.8141 13.238 14.6239C12.019 15.4337 10.5698 15.8254 9.10873 15.74C7.6477 15.6545 6.25403 15.0965 5.13773 14.15C4.02143 13.2036 3.24298 11.9199 2.91968 10.4926C2.59639 9.06518 2.74577 7.5714 3.34531 6.23631C3.94485 4.90122 4.96206 3.79716 6.24368 3.09049C7.52529 2.38382 9.00186 2.11284 10.4509 2.31837C11.8999 2.5239 13.2429 3.19481 14.2774 4.23001L17.7499 7.50001" stroke="#F8F7F2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_155_1446"><rect width="18" height="18" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';

	var iconTitle = '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.1956 5.96875L21.8831 2.6875C21.7718 2.40988 21.5796 2.17209 21.3316 2.00494C21.0835 1.83778 20.791 1.74897 20.4919 1.75H17.25V1C17.25 0.801088 17.171 0.610322 17.0303 0.46967C16.8897 0.329018 16.6989 0.25 16.5 0.25H2.25C1.85218 0.25 1.47064 0.408035 1.18934 0.68934C0.908035 0.970644 0.75 1.35218 0.75 1.75V12.25C0.75 12.6478 0.908035 13.0294 1.18934 13.3107C1.47064 13.592 1.85218 13.75 2.25 13.75H3.84375C4.00898 14.3953 4.38428 14.9673 4.91048 15.3757C5.43669 15.7842 6.08387 16.0059 6.75 16.0059C7.41613 16.0059 8.06331 15.7842 8.58952 15.3757C9.11573 14.9673 9.49102 14.3953 9.65625 13.75H14.3438C14.509 14.3953 14.8843 14.9673 15.4105 15.3757C15.9367 15.7842 16.5839 16.0059 17.25 16.0059C17.9161 16.0059 18.5633 15.7842 19.0895 15.3757C19.6157 14.9673 19.991 14.3953 20.1563 13.75H21.75C22.1478 13.75 22.5294 13.592 22.8107 13.3107C23.092 13.0294 23.25 12.6478 23.25 12.25V6.25C23.2503 6.15361 23.2318 6.0581 23.1956 5.96875ZM17.25 3.25H20.4919L21.3919 5.5H17.25V3.25ZM2.25 1.75H15.75V7.75H2.25V1.75ZM6.75 14.5C6.45333 14.5 6.16332 14.412 5.91665 14.2472C5.66997 14.0824 5.47771 13.8481 5.36418 13.574C5.25065 13.2999 5.22094 12.9983 5.27882 12.7074C5.3367 12.4164 5.47956 12.1491 5.68934 11.9393C5.89912 11.7296 6.16639 11.5867 6.45737 11.5288C6.74834 11.4709 7.04994 11.5006 7.32403 11.6142C7.59811 11.7277 7.83238 11.92 7.9972 12.1666C8.16203 12.4133 8.25 12.7033 8.25 13C8.25 13.3978 8.09197 13.7794 7.81066 14.0607C7.52936 14.342 7.14783 14.5 6.75 14.5ZM14.3438 12.25H9.65625C9.49102 11.6047 9.11573 11.0327 8.58952 10.6243C8.06331 10.2158 7.41613 9.99412 6.75 9.99412C6.08387 9.99412 5.43669 10.2158 4.91048 10.6243C4.38428 11.0327 4.00898 11.6047 3.84375 12.25H2.25V9.25H15.75V10.4041C15.4051 10.6034 15.1032 10.8692 14.8619 11.1861C14.6205 11.5029 14.4444 11.8646 14.3438 12.25ZM17.25 14.5C16.9533 14.5 16.6633 14.412 16.4166 14.2472C16.17 14.0824 15.9777 13.8481 15.8642 13.574C15.7507 13.2999 15.7209 12.9983 15.7788 12.7074C15.8367 12.4164 15.9796 12.1491 16.1893 11.9393C16.3991 11.7296 16.6664 11.5867 16.9574 11.5288C17.2483 11.4709 17.5499 11.5006 17.824 11.6142C18.0981 11.7277 18.3324 11.92 18.4972 12.1666C18.662 12.4133 18.75 12.7033 18.75 13C18.75 13.3978 18.592 13.7794 18.3107 14.0607C18.0294 14.342 17.6478 14.5 17.25 14.5ZM21.75 12.25H20.1563C19.989 11.6063 19.613 11.0362 19.0871 10.629C18.5612 10.2218 17.9151 10.0006 17.25 10V7H21.75V12.25Z" fill="#E94A77"/></svg>';

	var shippingFormStructure = `
		<form class="shipping-calc-wrapper">
			<label for="shipping-calculator-input" class="title-calc">${iconTitle} ${window.shippingCalculator.shippingEstimatorTitle}</label>
			<div class="shipping__input-and-button">
				<input value='' id="shipping-calculator-input" type="text" name="shipping_address[zip]" placeholder="Insira seu CEP" />
				<button type="submit" class="button shippingCalcButton button--primary">${iconButton}</button>
			</div>
			<div class="shipping__title-and-link">
				<a target="_blank" class="link-code" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei meu CEP</a>
			</div>
			<p class="message"></p>
		</form>
	`

	/* add to the page */
	productSection.innerHTML = shippingFormStructure;

	var shippingZip = document.querySelector('#shipping-calculator-input');
	var shippingCalcButton = document.querySelector('.shippingCalcButton');
	var shippingMessage = document.querySelector('.shipping-calc-wrapper .message');

	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	function initFields (){

		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';

		/* create the province state picker */
		var provinces = ['Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal', 'Espírito Santo', 'Goiás', 'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco', 'Piauí', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima', 'Santa Catarina', 'São Paulo', 'Sergipe', 'Tocantins'];

		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i===0));
		};
		shippingProvince.name = 'shipping_address[province]';

		shippingCalcButton.onclick=function(){
			shippingMessage.innerHTML = '';
			if(!productSelect.value.length){ return false }
			if(shippingZip.value != ''){
				shippingCalcButton.innerHTML = '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

				shippingCalcButton.setAttribute("disabled", true);
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');

			}
			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }
			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));
			getRates(parseInt(productSelect.value));
			return false;
		};

	};
	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};
	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};
	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};
	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};
	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }
		/* the main quantity element */
		var productQuantity = document.querySelector('quantity-selector .quantity-selector__input');
		var quantity = productQuantity ? parseInt(productQuantity.value) : 1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};
		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
			/* we have JSON */
			//console.log(json);
			/* Change the cookie value back to what it was */
			fetch('/cart/shipping_rates.json?' + new URLSearchParams({
				'shipping_address[country]':shippingCountry.value,
				'shipping_address[province]':shippingProvince.value,
				'shipping_address[zip]':shippingZip.value
			})).then(function(response) {
				return response.json();
			}).then(function(result) {
				if(result.shipping_rates && result.shipping_rates.length){
					let messageHtml = '<ul>'
					for (let i = 0; i < result.shipping_rates.length; i++) {
						const element = result.shipping_rates[i];
				
						// Verifica se há informação de dias de entrega
						let deliveryDays = '';
						if (element.delivery_days.length > 0) {
							if (element.delivery_days[0] == 1) {
								deliveryDays = '<span>1 dia útil</span>'
							} else {
								deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`
							}
						}
				
						// Formata o valor do frete para trocar "0,00" por "Gratis"
						let displayedPrice = element.price.replace('.', ',');
						if (displayedPrice === '0,00') {
							displayedPrice = 'Gratis';
						} else {
							displayedPrice = 'R$ ' + displayedPrice;
						}
				
						// Monta o HTML final para cada método de envio
						messageHtml += `
						<li> 
							${element.name} por <b>${displayedPrice}</b>
							<br>
							${deliveryDays ? deliveryDays : ''}
						</li>
						`;
						if (i === result.shipping_rates.length) {
							messageHtml += '</ul>'
						}
					}
					shippingMessage.innerHTML = messageHtml;
					document.querySelector('.shippingCalcButton').innerHTML = iconButton;
					document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
					shippingCalcButton.removeAttribute("disabled");
				}
				
				else {
					shippingMessage.className = 'message error'
					shippingMessage.innerHTML = window.shippingCalculator.shippingEstimatorMessageError;
					document.querySelector('.shippingCalcButton').innerHTML = iconButton;
					shippingCalcButton.removeAttribute("disabled");
				}
				resetCartCookie()
			}).catch(function() {
				resetCartCookie();
				shippingMessage.innerHTML = '';
				document.querySelector('.shippingCalcButton').innerHTML = iconButton;
				shippingCalcButton.removeAttribute("disabled");
			})
		}).catch(function(err) {
			/* uh oh, we have error. */
			console.error(err);
			resetCartCookie()
		});
	};

	initFields();
})()